import aboutUsImage from '../realtor-section-1-illustration.png';
import flagsImage from '../realtor-section-flags.png';
import photoUser from '../photoUser.png';
import photoUser1 from '../photoUser1.png';
import photoUser2 from '../photoUser2.png';
import flagAmerica from '../flagAmerica.png';
import flagGermany from '../flagGermany.png';
import flagJapan from '../flagJapan.png';
import privateBrokerage from '../privateBrokerage.png';
import estateBoard from '../estateBoard.png';
import virtualTour from '../virtualTour.png';
import aboutLeads from '../aboutLeads.png';
import nextArrow from '../nextArrow.png';
import sample1 from './sliderLanding/sample1.png';
import sample2 from './sliderLanding/sample2.png';
import sample3 from './sliderLanding/sample3.png';
import sample4 from './sliderLanding/sample4.png';
import sample5 from './sliderLanding/sample5.png';
import sample6 from './sliderLanding/sample6.png';
import partnerLogo from '../partner-logo.png';
import prevArrow from '../prevArrow.png';
import manufacturer from '../manufacturer.png';
import cross from '../cross.png';
import checkMark from '../checkMark.png';
import backgroundСomments from '../backgroundСomments.png';
import recomment1 from '../recomment1.png';
import recomment2 from '../recomment2.png';
import theMarker from '../theMarker.png';
import haaretz from '../haaretz.png';
import calcalist from '../calcalist.png';
import theMarkerSample from '../theMarkerSample.png';
import haaretzSample from '../haaretzSample.png';
import calcalistSample from '../calcalistSample.png';
import reliableBroker from '../reliableBroker.png';
import sellAHouse from '../sellAHouse.png';
import speciallyRealEstateAgents from '../speciallyRealEstateAgents.png';
import connectionBetweenPublicTransport from '../connectionBetweenPublicTransport.png';
import newsletter from '../newsletter.png';
import chekMark from '../chek_mark.png';

export default {
  aboutUsImage,
  flagsImage,
  photoUser,
  photoUser1,
  photoUser2,
  flagAmerica,
  flagGermany,
  flagJapan,
  privateBrokerage,
  estateBoard,
  virtualTour,
  aboutLeads,
  sample1,
  sample2,
  sample3,
  sample4,
  sample5,
  sample6,
  partnerLogo,
  nextArrow,
  prevArrow,
  manufacturer,
  cross,
  checkMark,
  backgroundСomments,
  recomment1,
  recomment2,
  theMarker,
  haaretz,
  calcalist,
  theMarkerSample,
  haaretzSample,
  calcalistSample,
  reliableBroker,
  sellAHouse,
  speciallyRealEstateAgents,
  connectionBetweenPublicTransport,
  newsletter,
  chekMark
};
